import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getSuiteLegalDisclaimerUrl } from 'pricing-pages-lib/utils/urls';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { PRODUCT_PAGE_HEADER } from '../../constants/tracking/Locations';
import CalculatorAnchorLink from '../common/CalculatorAnchorLink';
const StyledSubtitle = styled.div.withConfig({
  displayName: "ProductPageSubtitle__StyledSubtitle",
  componentId: "sc-8c76f5-0"
})(["text-align:center;font-size:0.875rem;margin-bottom:34px;line-height:normal;color:", ";& > p{margin-top:0;margin-bottom:0;}", ""], OBSIDIAN, breakpoint.phone(_t || (_t = _`
    padding: 0px 9px;
  `)));

const ProductPageSubtitle = ({
  productLine,
  nonProductIdentifier
}) => {
  if (nonProductIdentifier === NavItemEnum.COMMERCE) {
    productLine = COMMERCE;
  }

  const handleLegalLinkClick = () => {
    getUsageTracker().track('externalLinkClick', {
      name: 'legal-stuff',
      url: getSuiteLegalDisclaimerUrl(),
      trackingSource: PRODUCT_PAGE_HEADER,
      screen: NavItemEnum.SUITE
    });
  };

  const translationKeyMap = {
    [MARKETING]: 'pricingPage.pages.products.tabs.marketing.description',
    [SALES]: 'pricingPage.pages.products.tabs.sales.description',
    [SERVICE]: 'pricingPage.pages.products.tabs.service.description',
    [CMS]: 'pricingPage.pages.products.tabs.cms.description',
    [OPERATIONS]: 'pricingPage.pages.products.tabs.operations.description',
    [COMMERCE]: 'pricingPage.pages.products.tabs.commerce.description',
    [NavItemEnum.BUNDLE]: 'pricingPage.pages.products.tabs.bundle.description',
    [NavItemEnum.FREE]: 'pricingPage.pages.products.tabs.crm.description'
  };
  return /*#__PURE__*/_jsx(StyledSubtitle, {
    children: nonProductIdentifier === NavItemEnum.SUITE ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.suite.subtitle"
        }), /*#__PURE__*/_jsx(UILink, {
          className: "m-left-1",
          external: true,
          href: getSuiteLegalDisclaimerUrl(),
          onClick: handleLegalLinkClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.suite.details"
          })
        })]
      }), /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(UIHelpIcon, {
          className: "m-right-2",
          size: "xxs",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.suite.freeUsersTooltip"
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.suite.unlimitedFreeUsers"
          })
        }), /*#__PURE__*/_jsx(CalculatorAnchorLink, {})]
      })]
    }) : /*#__PURE__*/_jsxs("p", {
      children: [productLine && translationKeyMap[productLine] && /*#__PURE__*/_jsx(FormattedMessage, {
        message: translationKeyMap[productLine]
      }), nonProductIdentifier && translationKeyMap[nonProductIdentifier] && /*#__PURE__*/_jsx(FormattedMessage, {
        message: translationKeyMap[nonProductIdentifier]
      }), nonProductIdentifier !== NavItemEnum.FREE && nonProductIdentifier !== NavItemEnum.BUNDLE && productLine !== COMMERCE && /*#__PURE__*/_jsx(CalculatorAnchorLink, {})]
    })
  });
};

export default ProductPageSubtitle;